import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { AiChatOneIcon, AiChatTextarea, OneModal } from '@factorialco/f0-react/dist/experimental'

import { useActivity } from 'modules/core/lib/activities/activity'
import { ActivityComponent } from 'modules/core/lib/activities/types'
import i18n from 'modules/core/lib/i18n'

import { initialSurveyPrompt } from './prompt'

const CONTAINER_STYLE = { width: '624px' }

const SKIP_BUTTON_STYLE = { bottom: '32px' }

export const CreateSurveyActivity: ActivityComponent = () => {
  const { open, closeActivity } = useActivity()

  const handleSend = async (message: string) => {
    initialSurveyPrompt.current = message

    closeActivity()

    return {
      id: '1',
      content: message,
      text: message,
      role: 'user' as const,
    }
  }

  return (
    <OneModal isOpen={open} onClose={closeActivity} position="fullscreen">
      <OneModal.Header title=" " />
      <OneModal.Content>
        <Box justifyContent="center" alignItems="center" height="s600">
          <Box gap="s24" style={CONTAINER_STYLE}>
            <Box gap="s20">
              <AiChatOneIcon size="lg" spin />
              <Box gap="s8">
                <Text.Header2 className="text-2xl font-semibold">
                  {i18n.t('surveys.new_create_survey_modal.title')}
                </Text.Header2>
                <Text.Normal className="text-base text-f1-foreground-secondary">
                  {i18n.t('surveys.new_create_survey_modal.description')}
                </Text.Normal>
              </Box>
            </Box>
            <AiChatTextarea
              onSend={handleSend}
              inProgress={false}
              submitLabel={i18n.t('surveys.new_create_survey_modal.submit_label')}
            />
          </Box>
        </Box>
        <Box
          position="absolute"
          width="full"
          justifyContent="center"
          alignItems="center"
          style={SKIP_BUTTON_STYLE}
        >
          <F0Button
            label={i18n.t('surveys.new_create_survey_modal.skip_label')}
            onClick={closeActivity}
            variant="ghost"
          />
        </Box>
      </OneModal.Content>
    </OneModal>
  )
}
